export default __webpack_public_path__ + "static/media/Ocean tide2.e2b68545.jpg";